package features.shifts.ui

import kotlinx.html.*
import kotlinx.html.js.onClickFunction
import features.teams.domain.Team
import AppState
import features.shifts.handlers.showCreateShiftModal
import features.shifts.handlers.showEditShiftModal
import features.shifts.handlers.deleteShiftConfirm


object ShiftsTab {
    fun render(parent: DIV, team: Team) {
        val shifts = AppState.shiftTemplates[team.id] ?: emptyList()
        val isOwner = team.role == "owner"
        val isArchived = team.isArchived
        
        parent.div {
            div("flex justify-between items-center mb-4") {
                h2("text-2xl font-bold") { +"Shift Templates (${shifts.size})" }
                
                // Only show Create button for owners of non-archived teams
                if (isOwner && !isArchived) {
                    button(classes = "bg-brand-cyan hover:bg-brand-green text-white px-4 py-2 rounded-lg font-medium transition flex items-center gap-2") {
                        onClickFunction = { showCreateShiftModal() }
                        span("text-xl") { +"+" }
                        +"Create Shift"
                    }
                }
            }
            
            if (shifts.isEmpty()) {
                div("text-center py-12 text-slate-500") {
                    img(src = "/images/empty-states/no-attendance.png", alt = "No shift templates") {
                        classes = setOf("w-48", "h-48", "mx-auto", "mb-4")
                    }
                    div("text-lg font-bold mb-2") { +"No shift templates yet" }
                    if (isOwner && !isArchived) {
                        p("text-sm") { +"Create your first shift template to get started" }
                    }
                }
            } else {
                div("grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4") {
                    shifts.forEach { shift ->
                        div("p-6 rounded-2xl border-2 transition hover:shadow-lg") {
                            style = "border-color: ${shift.color}; background: linear-gradient(135deg, ${shift.color}20, transparent)"
                            
                            div("text-2xl font-bold mb-2") {
                                style = "color: ${shift.color}"
                                +shift.code
                            }
                            div("text-lg font-semibold text-white mb-3") {
                                +"${shift.startTime} - ${shift.endTime}"
                            }
                            if (shift.startTime != "-") {
                                div("text-xs text-slate-400 mb-4") {
                                    +"9h 0m"
                                }
                            } else {
                                div("text-xs text-slate-400 mb-4") {
                                    +"Day Off"
                                }
                            }
                            
                            // Edit/Delete buttons (owner only, not archived)
                            if (isOwner && !isArchived) {
                                div("flex gap-2 pt-3 border-t border-dark-700/50") {
                                    button(classes = "flex-1 px-3 py-1.5 rounded-lg bg-dark-700/50 hover:bg-dark-600 text-white text-sm transition font-medium") {
                                        onClickFunction = { 
                                            console.log("Edit shift clicked: ${shift.id}")
                                            showEditShiftModal(shift)
                                        }
                                        +"✏️ Edit"
                                    }
                                    button(classes = "flex-1 px-3 py-1.5 rounded-lg bg-red-500/20 hover:bg-red-500/30 text-red-400 text-sm transition font-medium border border-red-500/30") {
                                        onClickFunction = { 
                                            console.log("Delete shift clicked: ${shift.id}")
                                            deleteShiftConfirm(shift.id, shift.code)
                                        }
                                        +"🗑️ Delete"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
